import { connect } from 'react-redux';

import InPageSearchDisplay from './in_page_search_display.jsx';

import {
  getPageEntityFuzzySearcher,
  getInPageSearch
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  setIsInPageSearchDisplayed,
  setInPageSearch,
  handleSearchResultClick
} from 'zoomforth_codesbane_viewer/action_creators/viewer.js';


const mapStateToProps = (state) => {
  const searchIndex = getPageEntityFuzzySearcher(state);
  const search = getInPageSearch(state);
  return {
    searchIndex,
    search
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSearchResultClick: (ident)=> {
      dispatch(handleSearchResultClick(ident));
    },
    onClose: ()=> {
      dispatch(setIsInPageSearchDisplayed(false));
    },
    onSearchChange: (value)=> {
      dispatch(setInPageSearch(value));
    }
  };
};


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InPageSearchDisplay);
